module.exports = __webpack_public_path__ + "img/sauna_tent_1.7ba3cde5.jpg";